import {
  IBaseConfig,
  ITable,
  IFormFieldFilter,
} from "@models/form/base-config";
import { InterfaceManagementEndpoints } from "@dmms/shared/data-access/interface-management/types/interface-management-endpoints";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
  IHardFormSelectParams,
} from "@hardcode-kz/ui";
import { GuideModalComponent } from "@modules/admin/modules/dictionary-modules/guide-modal/guide-modal.component";
import {
  IGuidePayload,
  IGuideResponse,
} from "@models/interface-management/guide";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";
import { LangEnum } from "@models/interface-management/localization";
import { Validators } from "@angular/forms";

export class GuideConfig implements IBaseConfig {
  version = 1;
  dicType = InterfaceManagementEndpoints.Guide;
  isCrudByModal = true;
  createModalComponent = GuideModalComponent;
  editModalComponent = GuideModalComponent;

  fields: IHardFormField[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.KZ, LangEnum.EN],
        ),
      },
    },
    {
      name: "roles",
      title: "dicTable.roles",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: "api/v1/ref/app-roles",
        multiple: true,
        validators: [Validators.required],
      } as IHardFormSelectParams,
    },
  ];

  tableConfig: ITable<IGuideResponse[]> = {
    showDefaultActions: true,
    tableColumns: "40px repeat(6, auto)",
    columns: [
      {
        name: "index",
        title: "#",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        name: "name",
        title: "dicTable.name",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        name: "isVideo",
        title: "dicTable.videoInstruction",
        type: HardTableColumnTypeEnum.Html,
      },
      {
        name: "isKzInstruction",
        title: "dicTable.pdfKzInstruction",
        type: HardTableColumnTypeEnum.Html,
      },
      {
        name: "isRuInstruction",
        title: "dicTable.pdfRuInstruction",
        type: HardTableColumnTypeEnum.Html,
      },
      {
        name: "isEnInstruction",
        title: "dicTable.pdfEnInstruction",
        type: HardTableColumnTypeEnum.Html,
      },
    ],
    dataCallback: this.dataCallback,
  };

  dataCallback(data: IGuideResponse[]) {
    return data.map((item) => ({
      ...item,
      isVideo: item?.videoUrl
        ? '<div class="text-xl icon-check-line"></div>'
        : "<div> - </div>",
      isKzInstruction: item?.documentUrl?.kz
        ? '<div class="text-xl icon-check-line"></div>'
        : "<div> - </div>",
      isRuInstruction: item?.documentUrl?.ru
        ? '<div class="text-xl icon-check-line"></div>'
        : "<div> - </div>",
      isEnInstruction: item?.documentUrl?.en
        ? '<div class="text-xl icon-check-line"></div>'
        : "<div> - </div>",
    }));
  }

  filterTemplateColumns = "1fr";
  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      type: HardFormFieldTypeEnum.Input,
      name: "searchTerm",
      placeholder: "base.search",
      outside: true,
    },
  ];
}
